import React, { lazy } from 'react';
import { Switch, Route, useRouteMatch } from 'react-router-dom';

const volunteerApplications = lazy(() => import('../../../container/volunteer-applications'));
const View = lazy(() => import('../../../container/volunteer-applications/View'));

function PagesRoute() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route exact path={`${path}/volunteer-applications`} component={volunteerApplications} />
      <Route exact path={`${path}/volunteer-applications/view/:slug`} component={View} />
    </Switch>
  );
}

export default PagesRoute;
